import styled from 'styled-components';
import { Nav, NavLink as NavLinkBase } from 'reactstrap';

import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';

const SettingsWrapper = styled.div`
  display: flex;
  .backgroundbox-wrapper {
    @media ${device.sm} {
      flex: 0 0 97%;
      margin-left: 6px;
      padding: 20px;
    }
    @media ${device.md} {
      flex: 0 0 98%;
      margin-left: 7px;
      padding: 25px;
    }
    @media ${device.lg} {
      flex: 0 0 97%;
      margin-left: 13px;
      padding: 25px;
    }
    @media ${device.xl} {
      flex: 0 0 92%;
      margin-left: 0;
      padding: 25px;
    }
  }
  .translate-button {
    align-items: center;
    background-color: ${colors.lightGray};
    border: none !important;
    border-radius: 2px;
    color: ${colors.black};
    font-size: 11px;
    height: 28px;
    text-transform: uppercase;
    width: 121px;
    span {
      margin-top: 5px;
    }
    .button__icon-wrapper {
      margin-right: 10px;
      svg {
        fill: ${colors.black};
        height: 19px;
        width: 24px;
      }
    }
    &:hover {
      background-color: ${colors.zambezi};
      color: ${colors.white};
      .button__icon-wrapper {
        svg {
          fill: ${colors.white};
        }
      }
    }
  }
`;

const NavHome = styled(Nav)`
  border-bottom: 1px solid ${colors.pattens};
  margin-top: 26px;
  @media ${device.sm} {
    display: none;
  }
  @media ${device.md} {
    display: block;
  }
  @media ${device.lg} {
    display: flex;
  }
  @media ${device.xl} {
    display: flex;
  }
`;

const OptionMenu = styled.div`
  width: 100%;
  cursor: pointer;
  height: 30px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 4px;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

const NavLink = styled(NavLinkBase)`
  border: none !important;
  border-bottom: ${({ selected }) => (selected ? '2px' : '1px')} solid ${({ color }) => color} !important;
  color: ${colors.black};
  cursor: pointer;
  font-family: ${fonts.default};
  font-size: ${fontSizes.xxs}px;
  font-weight: ${({ selected }) => (selected ? 'bold' : '500')};
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
`;

export { SettingsWrapper, NavHome, NavLink, OptionMenu };
